export default "__VITE_ASSET__XIoEofn0__"